//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'MarshallScoringSystem',
  data () {
    return {
      form: {
        pao2fio2: '',
        cr: '',
        sbp: '',
        sbpreaction: '',
        ph: ''
      },
      dataList: [
        {value: '0', name: '＞400mmHg'},
        {value: '1', name: '301~400mmHg'},
        {value: '2', name: '201~300mmHg'},
        {value: '3', name: '101~200mmHg'},
        {value: '4', name: '＜101mmHg'}
      ],
      dataList2: [
        {value: '0', name: '≤134umol/L'},
        {value: '1', name: '134-169umol/L'},
        {value: '2', name: '170-310umol/L'},
        {value: '3', name: '311-439umol/L'},
        {value: '4', name: '＞439umol/L'}
      ],
      dataList3: [
        {value: '0', name: '是'},
        {value: '1', name: '否'}
      ],
      dataList4: [
        {value: '1', name: '是'},
        {value: '2', name: '否'}
      ],
      dataList5: [
        {value: '0', name: '＞= 7.3'},
        {value: '3', name: '＜ 7.3'},
        {value: '4', name: '＜ 7.2'}
      ],
      hasScore: false,
      disabled: false,
      descTxt1: '',
      descTxt2: '',
      descTxt3: ''
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      console.log(form)
      let result = Number(form.pao2fio2) + Number(form.cr) + Number(form.sbp) + Number(form.sbpreaction) + Number(form.ph)
      if (form.pao2fio2 >= 2) {
        self.descTxt1 = '呼吸衰竭'
      }
      if (form.cr >= 2) {
        self.descTxt2 = '肾脏衰竭'
      }
      if (form.sbp === 0) {
        // 收缩压（SBP）<90mmHg
        if (form.sbpreaction === 2 || form.ph >= 3) {
          self.descTxt3 = '心脏衰竭'
        }
      }
      self.hasScore = true
      return String(result)
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/GD/MarshallScoringSystem.vue